export function popup() {
  const triggers = document.querySelectorAll('.js-popup-trigger');
  if (triggers.length === 0) return;
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const popupId = this.getAttribute('data-popup-id');
      const popup = document.querySelector(`[data-popup-target="${popupId}"]`);

      if (popup) {
        popup.classList.add('is-visible');
        document.body.style.overflow = 'hidden';

        const closeBtn = popup.querySelector('.js-popup-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            closePopup(popup);
          });
        }

        popup.addEventListener('click', function(e) {
          if (e.target === popup) {
            closePopup(popup);
          }
        });

        document.addEventListener('keydown', function escHandler(e) {
          if (e.key === 'Escape') {
            closePopup(popup);
            document.removeEventListener('keydown', escHandler);
          }
        });
      }
    });
  });
  function closePopup(popup) {
    popup.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
}